<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-genres'"
    :addButton="false"
    :addLink="false"
    :leftMenu="[
            { text: `+ ${$t('load_tasks')}`, value: 'load_tasks' },
            { text: `+ ${$t('add_task')}`, value: 'add_task' },
          ]"
     @menuClick="onRightMenuClick"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-related-genres"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td  @click="onClick(item)" v-bind="tdcon('task')">
            <span class="ut-link ut-text-accent5">{{ item["task"] }}</span>
          </td>

          <td v-bind="tdcon('status')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="false"
              :options="statusTV"
              :selected="
                statusTV.find(v => v.value == item.status)
              "
              :placeholder="$t('status')"
              v-on:selectedChange="e => onDropdownChange(item, e)"
              :style="{
                  maxWidth: '100%',
                  width: '100%',
                }"
                bb="0"
            />
          </td>
          <td v-bind="tdcon('due_date')">
            <span>{{ item["due_date"] }}</span>
          </td>
          <td v-bind="tdcon('users')">
            <span>{{ item["users"] }}</span>
          </td>
          <td v-bind="tdcon('notes')">
            <TextField2
              type="text"
              class="dbox1"
              id="notes"
              :showLabel="false"
              :disabled="false"
              :value="item['notes']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => onDeleteTask(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
    <template v-if="dtLoadTaskSingleModalContainer">
      <v-dialog v-model="dtLoadTaskSingleModal" persistent width="400">
        <DTTaskLoadSingleModal
          @cancelled="onCancel"
          @onSubmit="onSubmit"
        />
      </v-dialog>
    </template>
    <template v-if="dtLoadTaskModalContainer">
      <v-dialog v-model="dtLoadTaskModal" persistent width="300">
        <DTTaskLoadModal
          @onLoadTask="onTaskLoad"
          @cancelled="onCancel"
          
        />
      </v-dialog>
    </template>
    <template v-if="dtAddTaskModalContainer">
      <v-dialog v-model="dtAddTaskModal" persistent width="400">
        <DTTaskAddModal
          @insert="onTaskAdd"
          @cancelled="onCancel"
        />
      </v-dialog>
    </template>
  </DBox>
</template>
<script>
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "@/plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "@/plugins/datatable";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import { closeModalRoute, createModalMixin, openModalRoute, openModalRoute2 } from "../modal/modal.mixin";
import DTTaskLoadModal from "./dt-task-load-modal.vue";
import DTTaskLoadSingleModal from "./dt-task-load-single-modal.vue";
import DTTaskAddModal from "./dt-task-add-modal.vue";
import { useDBoxStore } from "../dboxstore/dboxstore.mixin";
import { dtTaskService } from "./dt-task-service";
import { MHTTPCL } from "../../services/http/http-client";
import { format } from "date-fns";
export default {
  props: {
    selectedDetails: {
      type: Object
    },
    externalTable: {
      type: String
    }
  },
  components: {
    NTable,
    DBox,
    DTTaskLoadModal,
    DTTaskAddModal,
    DTTaskLoadSingleModal
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  mixins: [
    useDBoxStore(),
    createModalMixin("dtLoadTask"),
    createModalMixin("dtAddTask"),
    createModalMixin("dtLoadTaskSingle"),
  ],
  computed: {
    Headers: function() {
      return [
        createTableHeader("task", {}),
        createTableHeader("status", {}),
        createTableHeader("due_date", {}),
        createTableHeader("users", {}),
        createTableHeader("notes", {}),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedDetails.tasks || [];
    },
    statusTV: function() {
      return [
          {text:'open',value:'open'},
          {text:'pending',value:'pending'},
          {text:'question',value:'question'},
          {text:'done',value:'done'},
          {text:'rejected',value:'rejected'},
        ]
    }
  },
  methods: {

    onClick:function(item){
      console.log(item,":::::::::::")
      openModalRoute2(this,'dtLoadTaskSingle',{ externalTable:this.externalTable ,task_id:item.task_id})
    },
    onSubmit:async function(){
      const taskList = await dtTaskService.taskList(this.storeConfig.primaryKeyValue,this.externalTable);

      console.log(taskList,":::::::PIIIIIAAAA")
      this.dboxPluginStore.updateDBoxStoreState(
        (dboxData) => taskList.data.tasks
      );
    },
    onUpdate:async function(payload){
      console.log(payload,"ITEM ITEM")
      const { name ,value , item } =  payload;

      const { task_id } = item;
      if(name == 'extra_field'){
        //   this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
        //     return dboxData.map((x) => {
        //       if(x.task_id==task_id){
        //           return{
        //             ...x,
        //             json_data:{extra_fields:[...value]}
        //           }
        //       }
        //       return{
        //         ...x
        //       }
              
        //     });
        // });
        await MHTTPCL.modify(undefined,task_id,'json_data',JSON.stringify({extra_fields:value}),'tasks_user');
      }else{
        // this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
        //     return dboxData.map((x) => {
        //       if(x.task_id==task_id){
        //           return{
        //             ...x,
        //             name:value
        //           }
        //       }
        //       return{
        //         ...x
        //       }
              
        //     });
        // });
        await MHTTPCL.modify(undefined,task_id,name,value,'tasks_user');
        if(name=='status' && value == 'done'){
          const userId = this.$store.getters.account.user.user_id;

          const doneDate = format(new Date(),"YYYY-MM-DD")

          await MHTTPCL.modify(undefined,task_id,'done_user_id',userId,'tasks_user');
          await MHTTPCL.modify(undefined,task_id,'done_date',doneDate,'tasks_user');
        }
      }

     
    },
    onTextFieldChange:async function(e, item) {
      console.log(e, item)

      const { task_id } = item;
      
      const { name ,value} = e
      this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.map((x) => {
            if(x.task_id==task_id){
                return{
                  ...x,
                  notes:e.value
                }
            }
            return{
              ...x
            }
            
          });
      });

      await MHTTPCL.modify(undefined,task_id,name,value,'tasks_user');

    },
    onDropdownChange:async function(item, e) {

      console.log(e,"EEE")

      const { task_id } = item;
      

      this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.map((x) => {
            if(x.task_id==task_id){
                return{
                  ...x,
                  status:e.value
                }
            }
            return{
              ...x
            }
            
          });
      });

      if(e.value=='done'){
        await MHTTPCL.modify(undefined,task_id,'status',e.value,'tasks_user');
        const userId = this.$store.getters.account.user.user_id;

        const doneDate = format(new Date(),"YYYY-MM-DD")

        await MHTTPCL.modify(undefined,task_id,'done_user_id',userId,'tasks_user');
        await MHTTPCL.modify(undefined,task_id,'done_date',doneDate,'tasks_user');



        console.log(this.$store.getters.account.user.user_id,"STORE")
      }else{
        await MHTTPCL.modify(undefined,task_id,'status',e.value,'tasks_user');
      }

      

      console.log(item)

    },
    onCancel:function(){
      closeModalRoute(this)
    },
    onTaskLoad:async function(payload){
      const { task_group_id } = payload;
      const LoadTask = await dtTaskService.loadTaskAdd(this.storeConfig.primaryKeyValue,task_group_id);
      // const taskList = await dtTaskService.taskList(this.storeConfig.primaryKeyValue,this.externalTable);

      // console.log(taskList)
      // this.dboxPluginStore.updateDBoxStoreState(
      //   (dboxData) => taskList.data.tasks
      // );
      this.onSubmit();
      this.onCancel();
    },

    onTaskAdd:async function(payload){
      console.log("INSERT",payload)
      console.log("LOG LOG",this.$store.getters.account.user.user_id)
      const task = { ...payload, external_id:this.storeConfig.primaryKeyValue,external_table:this.externalTable,sent_user:this.$store.getters.account.user.user_id}

       const AddTask = await dtTaskService.addTaskUser({ ...task });
       this.onSubmit();
      //  const taskList = await dtTaskService.taskList(this.storeConfig.primaryKeyValue,this.externalTable);

      // this.dboxPluginStore.updateDBoxStoreState(
      //   (dboxData) => taskList.data.tasks
      // );
      this.onCancel();
    },

    onDeleteTask:async function(payload){
      const { task_id } =payload;
      this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.filter((e) => e.task_id != task_id);
        });

      await dtTaskService.deleteTask(task_id);
    },
    onRightMenuClick: async function (menu) {
      //this.$emit('menu', menu);
      //console.log('menu', menu)

      switch(menu) {
        case 'load_tasks':
        //dtLoadTaskModal
          openModalRoute2(this,'dtLoadTask',{ externalTable:this.externalTable })
          console.log("load")
          break;
        case 'add_task':
          openModalRoute2(this,'dtAddTask',{ externalTable:this.externalTable })
          break;
        default:
          break;
      }

    },

  }
};
</script>
